interface SessionStatusBadgeProps {
  status: 'Pending' | 'Confirmed' | 'Canceled';
}

function SessionStatusBadge({ status }: SessionStatusBadgeProps) {
  return <span className={`badge badge-${status.toLowerCase()}`}>{status}</span>;
}

export default SessionStatusBadge;
